<template>
    <svg version="1.1" class="logo-mark" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 50" style="enable-background:new 0 0 60 50;" xml:space="preserve">
        <g>
            <g>
                <path class="logo-swatch-0" d="M45,17.7l-8,3.5c-0.4,0.2-0.9,0-1-0.5l-1.8-8.8c-0.1-0.5,0.2-1,0.6-1.2l8-3.5c0.4-0.2,0.9,0,1,0.5l1.8,8.8
                    C45.7,16.9,45.4,17.5,45,17.7z"/>
                <path class="logo-swatch-1" d="M33.9,22.5l-8,3.5c-0.4,0.2-0.9,0-1-0.5l-1.8-8.8c-0.1-0.5,0.2-1,0.6-1.2l8-3.5c0.4-0.2,0.9,0,1,0.5l1.8,8.8
                    C34.6,21.7,34.3,22.3,33.9,22.5z"/>
            </g>
            <g>
                <path class="logo-swatch-2" d="M36.3,34.6l-8,3.5c-0.4,0.2-0.9,0-1-0.5l-1.8-8.8c-0.1-0.5,0.2-1,0.6-1.2l8-3.5c0.4-0.2,0.9,0,1,0.5l1.8,8.8
                    C37,33.9,36.8,34.4,36.3,34.6z"/>
                <path class="logo-swatch-3" d="M25.2,39.4l-8,3.5c-0.4,0.2-0.9,0-1-0.5l-1.8-8.8c-0.1-0.5,0.2-1,0.6-1.2l8-3.5c0.4-0.2,0.9,0,1,0.5l1.8,8.8
                    C25.9,38.7,25.6,39.2,25.2,39.4z"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "logo-mark",
}
</script>

<style scoped>
    .logo-swatch-0{fill:#006CE4;}
    .logo-swatch-1{fill:#F0583B;}
    .logo-swatch-2{fill:#B50097;}
    .logo-swatch-3{fill:#FFCD49;}
</style>